// src/App.js
import React from 'react';
import Login from './pages/Login';

function App() {
    return (
        <div>
            <Login />
        </div>
    );
}

export default App;
